import { render, staticRenderFns } from "./ResumenDenunciaModal.vue?vue&type=template&id=2d262c48"
import script from "./ResumenDenunciaModal.vue?vue&type=script&lang=js"
export * from "./ResumenDenunciaModal.vue?vue&type=script&lang=js"
import style0 from "./ResumenDenunciaModal.vue?vue&type=style&index=0&id=2d262c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports